import { z } from 'zod';

export const InProgressDisplayStatusSchema = z.enum([
  'UPLOAD_REQUIRED',
  'SHIPPING',
  'PREPARING_PRODUCT',
]);

export type InProgressDisplayStatus = z.infer<typeof InProgressDisplayStatusSchema>;

export const InProgressContentTypeSchema = z.enum([
  'IMAGE',
  'SHORT_FORM',
  'LONG_FORM',
  'TEXT',
  'BLOG_POST',
]);

export type InProgressContentType = z.infer<typeof InProgressContentTypeSchema>;

const ContentUploadDeadlineServiceSchema = z
  .object({
    contentType: InProgressContentTypeSchema.nullable().optional(),
    deadlineAt: z.string().nullable().optional(),
  })
  .describe('ContentUploadDeadlineServiceSchema');

export const InProgressCampaignServiceSchema = z
  .object({
    participationId: z.number(),
    campaignId: z.number(),
    displayStatus: InProgressDisplayStatusSchema,
    brandName: z.string(),
    goodsName: z.string(),
    goodsNo: z.number(),
    goodsImage: z.string(),
    selectedOptions: z.string(),
    contentUploadDeadline: ContentUploadDeadlineServiceSchema.nullable().optional(),
  })
  .describe('InProgressCampaignServiceSchema');

export type InProgressCampaignItem = z.infer<typeof InProgressCampaignServiceSchema>;

export const GetInProgressCampaignsServiceResponseSchema = z
  .object({
    campaigns: z.array(InProgressCampaignServiceSchema),
    totalCount: z.number(),
  })
  .describe('GetInProgressCampaignsServiceResponseSchema');

export type GetInProgressCampaignsServiceResponse = z.infer<
  typeof GetInProgressCampaignsServiceResponseSchema
>;
